<script>
	import { Col, Row, Button } from "@sveltestrap/sveltestrap";

	import ErrorMessageHandler from "../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import PageHeader from "../../../components/PageHeader/PageHeader.svelte";
	import { Splide, SplideSlide } from "@splidejs/svelte-splide";
	import LoaderContainer from "../../../components/Loader/LoaderContainer.svelte";
	import NoData from "../../../components/NoDataPage/NoData.svelte";
	import client from "../../../services/client";
	import { convert } from "../../../services/helpers";
	import {
		errorMessage,
		loading,
		loadSpinner,
		imageLightbox,
	} from "../../../store/store";
	import { onMount } from "svelte";
	import { navigate } from "svelte-routing";
	import "@splidejs/svelte-splide/css";
	import Lightbox from "../../../components/Lightbox/Lightbox.svelte";

	let issues = [];
	let img_url = [];

	onMount(async () => {
		try {
			loading.set(true);
			const res = await client("/v0/Issue/GetIssueForFilterMode", {
				method: "GET",
				version: "Tasking",
			});
			issues = res.data.data;
			img_url = res.data.data.imageUrls;
			imageLightbox.set(img_url);
			loading.set(false);
		} catch (err) {
			loading.set(false);

			if (err.response.Code === 498) {
				errorMessage.set(err.response.Message);
			} else {
				errorMessage.set(`Error status: ${err.response.status}`);
			}
		}
	});

	const fetchIssue = async (req, res) => {
		try {
			loading.set(true);
			const res = await client("/v0/Issue/GetIssueForFilterMode", {
				method: "GET",
				version: "Tasking",
			});
			issues = res.data.data;
			img_url = res.data.data.imageUrls;
			imageLightbox.set(img_url);
			loading.set(false);
		} catch (err) {
			loading.set(false);
			if (err.response.Code === 498) {
				errorMessage.set(err.response.Message);
			} else {
				errorMessage.set(`Error status: ${err.response.status}`);
			}
		}
	};

	let load = false;
	const handleApprove = async (issueId) => {
		load = true;
		loadSpinner.set(true);
		try {
			const res = await client("/v0/Issue/pass", {
				method: "POST",
				version: "Tasking",
				data: {
					issueId,
				},
			});
			load = false;
			loadSpinner.set(false);
			fetchIssue();
		} catch (err) {
			load = false;
			loadSpinner.set(false);
			if (err.response.Code === 498) {
				errorMessage.set(err.response.Message);
			} else {
				errorMessage.set(`Error status: ${err.response.status}`);
			}
		}
	};

	const handleReject = async (issueId, reason) => {
		try {
			loading.set(true);
			const res = await client("/v0/Issue/v2/Reject", {
				method: "POST",
				version: "Tasking",
				data: {
					issueId,
					rejectReason: reason,
					sourceTable: "FMS",
				},
			});
			fetchIssue();
		} catch (err) {
			console.log(err.response);
		}
	};

	// Do not change readonly options later, such as `type`, `preloadPages`, etc.
	let arrow = false;
	$: options = {
		rewind: true,
		gap: "0.5rem",
		autoWidth: "100%",
		height: "30rem",
		arrows: img_url.length < 2 ? false : true,
	};

	let err;
	errorMessage.subscribe((value) => {
		err = value;
	});

	let modalOpen = false;
	let imageShowingIndex = 0;

	const handleImgClick = (i) => {
		imageShowingIndex = Number(i);
		modalOpen = true;
		options.arrows = false;
	};
</script>

{#if modalOpen}
	<Lightbox on:click={() => (modalOpen = false)} {imageShowingIndex} />
{/if}

<Row>
	<Col xs={12}>
		<div>
			<LoaderContainer>
				{#if !issues}
					<NoData />
				{:else}
					<ErrorMessageHandler message={err} />
					<Col class="row d-flex align-items-start me-0 my-4">
						<PageHeader title="Filter Mode" />
					</Col>

					<Col>
						<Row class="carousel-detail g-0 mx-0">
							<Col xs={12}>
								<Splide
									{options}
									aria-label="My Favorite Images"
								>
									{#each img_url as slide, index}
										<SplideSlide>
											<!-- svelte-ignore a11y-click-events-have-key-events -->
											<img
												src={slide}
												alt="alt"
												style="width: 100%;  height:100%; object-fit: scale-down; "
												class=""
												on:click={() =>
													handleImgClick(index)}
											/>
										</SplideSlide>
									{/each}
								</Splide>
							</Col>
							<Col xs={12} class="mt-4 px-2">
								<Col
									xs={12}
									class="d-flex justify-content-start px-2"
								>
									<div class="mx-0">
										<h4 class="link">
											<!-- svelte-ignore a11y-click-events-have-key-events -->
											<b
												class="link-text-hover"
												on:click={() =>
													navigate(
														`/car-management/details/${issues.vehicleId}`
													)}
											>
												{issues.vehicleMake +
													" " +
													issues.vehicleModel +
													" " +
													issues.vehicleNumber}
											</b>
										</h4>
									</div>
									<div class="mx-2">
										<p
											class="status-bar-info status-bar-info-1"
										>
											Color: {issues.vehicleColor}
										</p>
									</div>
									<div class="mx-2">
										<p
											class="status-bar-info status-bar-info-1"
										>
											Issue ID: {issues.issueId}
										</p>
									</div>
								</Col>
							</Col>
							<Col xs={6} class="px-2 my-2">
								<Col xs={6} class="my-4 px-2">
									<Row class="my-3">
										<Col>
											<span> Category: </span>
										</Col>
										<Col>
											<b> {issues.reportSection} </b>
										</Col>
									</Row>
									<Row class="my-3">
										<Col><span>Damage Area</span></Col>
										<Col>
											<b> {issues.carSection} </b>
										</Col>
									</Row>
									<Row class="my-3">
										<Col><span>Damage Type</span></Col>
										<Col>
											<b> {issues.damageType} </b>
										</Col>
									</Row>
									<Row class="my-3">
										<Col><span>Date Reported</span></Col>
										<Col>
											<b>
												{convert(issues.dateReported)}
											</b>
										</Col>
									</Row>
								</Col>
							</Col>
							<Col xs={6}>
								<Row class="my-2">
									{#if load}
										<div
											class="d-flex justify-content-end pe-5"
										>
											<Button
												class="customButton primary-blue"
												type="button"
												disabled
											>
												<output
													class="spinner-grow spinner-grow-sm"
													aria-hidden="true"
												/>
												Loading...
											</Button>
										</div>
									{:else}
										<span
											class="d-flex justify-content-end pe-5"
										>
											<Button
												class="customButton primary-blue "
												on:click={() =>
													handleApprove(
														issues.issueId
													)}
											>
												Accept
											</Button>
										</span>
									{/if}
								</Row>
								<Row class="my-2">
									<span
										class="d-flex justify-content-end pe-5"
									>
										<Button
											class="customButton primary-white "
											on:click={() =>
												handleReject(
													issues.issueId,
													"Blur"
												)}>Reject; Blur</Button
										>
									</span>
								</Row>
								<Row class="my-2">
									<span
										class="d-flex justify-content-end pe-5"
									>
										<Button
											class="customButton primary-white "
											on:click={() =>
												handleReject(
													issues.issueId,
													"Not Billable"
												)}>Reject; Not Billable</Button
										>
									</span>
								</Row>
								<Row class="my-2">
									<span
										class="d-flex justify-content-end pe-5"
									>
										<Button
											class="customButton primary-white "
											on:click={() =>
												handleReject(
													issues.issueId,
													"Irrelevant"
												)}>Reject; Irrelevant</Button
										>
									</span>
								</Row>
							</Col>
						</Row>
					</Col>
				{/if}
			</LoaderContainer>
		</div>
	</Col>
</Row>

<style>
	:global(.carousel-detail) {
		border: 0.5px solid gray;
		margin-left: 0px !important;
		border-radius: 10px;
		overflow: hidden;
		box-shadow: 0px 0px 1px 1px rgba(154, 146, 146, 0.5);
	}
</style>
